export const aidServices = {
    BROKEN_GLASS: 'BROKEN_GLASS',
    MARTEN_BITE: 'MARTEN_BITE',
    ROADKILL: 'ROADKILL',
    ELEMENTAL_DAMAGE: 'ELEMENTAL_DAMAGE',
};
